/* =====================================================
   KLEO — Custom JavaScript
   ===================================================== */

(function () {
  'use strict';

  /* === HEADER SCROLL === */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* === MOBILE MENU === */
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      mobileMenuBtn.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* === CART DRAWER === */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBtns = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartItems();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  /* === CART API === */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      console.error('Cart fetch error:', e);
      return null;
    }
  }

  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      const data = await res.json();
      updateCartCount();
      openCart();
      return data;
    } catch (e) {
      console.error('Add to cart error:', e);
    }
  }

  async function updateCartCount() {
    const cart = await fetchCart();
    if (!cart) return;
    const countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  async function renderCartItems() {
    const cart = await fetchCart();
    const body = document.getElementById('cart-drawer-body');
    const totalEl = document.getElementById('cart-drawer-total');
    if (!body || !cart) return;

    const isHebrew = document.documentElement.lang === 'he';

    if (cart.items.length === 0) {
      body.innerHTML = `
        <div style="text-align:center; padding: 48px 24px; color: #6B6B6B;">
          <div style="font-size:48px; margin-bottom:16px;">🛒</div>
          <p style="font-size:1rem;">${isHebrew ? 'הסל שלך ריק' : 'Your cart is empty'}</p>
        </div>
      `;
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '<div class="placeholder-img">🐾</div>'}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__price">${isHebrew ? 'כמות' : 'Qty'}: ${item.quantity} × ${formatMoney(item.price)}</div>
        </div>
      </div>
    `).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return '₪' + (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* === ADD TO CART BUTTONS === */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    const variantId = btn.dataset.variantId || btn.dataset.addToCart;
    if (!variantId) return;

    const isHebrew = document.documentElement.lang === 'he';
    const originalText = btn.textContent;

    btn.textContent = isHebrew ? 'מוסיף...' : 'Adding...';
    btn.disabled = true;

    // Get quantity from adjacent selector
    const qtyInput = btn.closest('form')?.querySelector('.quantity-input') ||
                     document.querySelector('.quantity-input');
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;

    await addToCart(variantId, qty);

    btn.textContent = isHebrew ? '✓ נוסף לסל' : '✓ Added!';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  });

  /* === QUANTITY SELECTOR === */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;

    const input = btn.closest('.quantity-selector')?.querySelector('.quantity-input');
    if (!input) return;

    const action = btn.dataset.qty;
    const current = parseInt(input.value) || 1;

    if (action === 'plus') input.value = current + 1;
    if (action === 'minus' && current > 1) input.value = current - 1;
  });

  /* === PRODUCT GALLERY === */
  const galleryMain = document.querySelector('.gallery-main-img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      if (!galleryMain) return;

      const fullSrc = thumb.dataset.fullSrc;
      const fullSrcset = thumb.dataset.fullSrcset;
      const alt = thumb.dataset.alt;

      if (fullSrc) galleryMain.src = fullSrc;
      if (fullSrcset) galleryMain.srcset = fullSrcset;
      if (alt) galleryMain.alt = alt;
    });

    // Also support keyboard navigation
    thumb.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumb.click();
      }
    });
  });

  /* === FAQ ACCORDION === */
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item.open').forEach(openItem => {
        openItem.classList.remove('open');
      });

      // Toggle current
      if (!isOpen) item.classList.add('open');
    });
  });

  /* === SCROLL ANIMATIONS === */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -48px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll(
    '.product-card, .why-card, .review-card, .feature-block, .trust-item'
  ).forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  document.addEventListener('animationend', (e) => {}, { once: true });

  // CSS class approach
  const style = document.createElement('style');
  style.textContent = `
    .animate-in {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);

  /* === EMAIL SIGNUP === */
  const emailForms = document.querySelectorAll('.kleo-email-form');
  emailForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]')?.value;
      if (!email) return;

      const isHebrew = document.documentElement.lang === 'he';
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn?.textContent;

      if (btn) {
        btn.textContent = isHebrew ? 'שולח...' : 'Sending...';
        btn.disabled = true;
      }

      // Shopify Newsletter signup via Customer API
      try {
        const formData = new FormData();
        formData.append('customer[email]', email);
        formData.append('customer[accepts_marketing]', 'true');
        formData.append('form_type', 'customer');

        await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData
        });

        if (btn) btn.textContent = isHebrew ? '✓ נרשמת בהצלחה!' : '✓ Subscribed!';
        form.querySelector('input[type="email"]').value = '';
      } catch (err) {
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }
    });
  });

  /* === LANGUAGE TOGGLE === */
  document.querySelectorAll('.lang-switch').forEach(link => {
    link.addEventListener('click', (e) => {
      // Shopify will handle locale switching via URL
      // Links like /he and /en handled natively
    });
  });

  /* === INIT === */
  updateCartCount();

})();
